import type { ChatFetchers } from '../../fetchers/chat/chat-fetchers';
import { useApplicationFetchers } from '../../fetchers/use-application-fetchers';

export const useFetchChatThreadMessages = (): ChatFetchers['fetchChatThreadMessages'] =>
    useApplicationFetchers().fetchChatThreadMessages;
